import { chainOrSuspend, pyNone } from "@Sk";
import PyDefUtils from "PyDefUtils";
import { Component, ComponentConstructor } from "@runtime/components/Component";
import { BASE_MODULES } from "../python-environment";

const DesignYouTubeVideo = BASE_MODULES["anvil"]["DesignYouTubeVideo"];

export const DesignYouTubeVideoV3 = Sk.misceval.buildClass(
    BASE_MODULES["anvil"],
    ($gbl, $loc) => {
        $loc["__init__"] = PyDefUtils.funcFastCall(([self]: [Component], kws) =>
            chainOrSuspend(DesignYouTubeVideo.prototype.tp$init.call(self, [], kws), () => {
                self._anvil.elements.iframe.style.pointerEvents = "none";

                PyDefUtils.addHeightHandle(self._anvil);

                return pyNone;
            })
        );
    },
    "DesignYouTubeVideoV3",
    [DesignYouTubeVideo]
) as ComponentConstructor;
